export default __webpack_public_path__ + "static/media/dropdown.1e089686.svg";